import { connect } from "react-redux";
import ProductRating from "app/pages/FicheProduit/components/ProductRating/ProductRating";
import { getSDPProductsRating } from "app/pages/SmartDP/Listing/SmartDPFilters/smartDPProductsFilterSelectors";

const mapStateToProps = state => ({
	ratingType: getSDPProductsRating(state),
});

export default connect(mapStateToProps)(ProductRating);
